import React, { useEffect, useState } from 'react';
import { AlertTriangle } from 'lucide-react';
import axios from '../../axios/AxiosInstance';
import { clientInvoices } from '../../utils/clientInvoices';
import { isInvoiceOverdue } from '../../utils/invoiceDueDate';

export default function ClientOverdueWarning({ client, onClick }) {
  const [count, setCount] = useState(0);
  useEffect(() => {
    let active = true;
    setCount(0);
    axios.get('facture/freelance').then(({ data }) => {
      if (active) setCount(clientInvoices(Array.isArray(data) ? data : [], client).filter(invoice => isInvoiceOverdue(invoice)).length);
    }).catch(() => {});
    return () => { active = false; };
  }, [client]);
  if (!count) return null;
  return <button type="button" onClick={onClick} title={`${count} facture${count > 1 ? 's' : ''} non réglée${count > 1 ? 's' : ''} après échéance · Voir les factures`} className="inline-flex items-center gap-1.5 rounded-full border border-red-600 bg-red-600 px-2.5 py-1 text-xs font-semibold text-white hover:bg-red-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-red-600"><AlertTriangle size={16} aria-hidden="true" />{count} impayé{count > 1 ? 's' : ''}</button>;
}
